import styled from "styled-components";

export const ProductWarrantyStoreNameFormStyled = styled.div`
  .f_title {
    margin-bottom: 30px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.BLACK_2};
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
  }
  .input_wrap {
    margin-bottom: 16px;
  }
  .btn_submit {
    margin-top: 28px;
    margin-left: auto;
    margin-right: 0px;
    width: 186px;
  }
`;
